module.exports = new __parcel__URL__("map-darkmode.65c31cec.svg").toString();